import IconButton from '@common/components/controls/IconButton';
import Menu from '@common/components/Menu';
import MenuActionOption from '@common/components/Menu/MenuActionOption';
import MenuNavigationOption from '@common/components/Menu/MenuNavigationOption';
import ColorThemesMenu from '@common/components/PageHeader/PageHeaderMenu/ColorThemesMenu';
import IconBurgerMenu from '@common/components/svgs/common/BurgerMenu';

interface AuthenticatedMobileMenuProps {
  logout: () => void;
  openFeedbackPopup?: () => void;
  mustAcceptEula: boolean | undefined;
  showBetaFeatures?: boolean;
}

function AuthenticatedMobileMenu({
  logout,
  openFeedbackPopup,
  mustAcceptEula,
  showBetaFeatures,
}: Readonly<AuthenticatedMobileMenuProps>) {
  return (
    <Menu
      align="right"
      fullWidth
      renderSelector={(selectorRef, toggleMenu) => (
        <div ref={selectorRef}>
          <IconButton
            icon={IconBurgerMenu}
            onClick={toggleMenu}
            data-testid="openMobileMenuButton"
          />
        </div>
      )}
    >
      {mustAcceptEula === false && (
        <>
          <MenuNavigationOption
            id="menu.option.devices"
            to={{ pathname: '/devices' }}
            tagName="h5"
            withArrow
            data-testid="showDevices-menunavigation"
          />
          <MenuNavigationOption
            id="menu.option.account"
            to={{ pathname: '/account' }}
            tagName="h5"
            withArrow
            data-testid="showAccount-menunavigation"
          />
          {showBetaFeatures && (
            <MenuNavigationOption
              id="menu.option.beta-features"
              to={{ pathname: '/beta-features' }}
              tagName="h5"
              withArrow
              data-testid="showBetaFeatures-menunavigation"
            />
          )}
        </>
      )}
      {openFeedbackPopup && (
        <MenuActionOption
          id="menu.option.send-feedback"
          onClick={openFeedbackPopup}
          tagName="h5"
          data-testid="sendFeedback-menuaction"
        />
      )}
      <ColorThemesMenu />
      <MenuActionOption
        id="menu.option.logout"
        data-testid="logoutButton"
        onClick={logout}
        tagName="h5"
        style={{ color: 'var(--color-ui-brand)' }}
      />
    </Menu>
  );
}

export default AuthenticatedMobileMenu;
